import { UnitOfAreaMeasurement } from "./types";

const CONST_F = 10.7639
const CONST_ACRE = 43560
const CONST_HECTARE = 107639.104167

export function convertSize(
  value: number, 
  srcUnitOfAreaMeasurement: UnitOfAreaMeasurement,
  dstUnitOfAreaMeasurement: UnitOfAreaMeasurement
): number {
  if (srcUnitOfAreaMeasurement === dstUnitOfAreaMeasurement) return value;
  const sizeInMeter = sizeInMetric(value, srcUnitOfAreaMeasurement)
  if (dstUnitOfAreaMeasurement === 'sqft') return sizeInMeter * CONST_F;
  if (dstUnitOfAreaMeasurement === 'ha') return sizeInMeter / 10000;
  if (dstUnitOfAreaMeasurement === 'ac') return sizeInMeter / 4047;
  return sizeInMeter
}

export function sizeInMetric(value: number, unitOfAreaMeasurement: UnitOfAreaMeasurement): number {
  if (unitOfAreaMeasurement === 'sqft') return value / CONST_F;
  if (unitOfAreaMeasurement === 'ha') {
    const sizeInFoot = value * CONST_HECTARE
    return sizeInFoot / CONST_F;
  }
  if (unitOfAreaMeasurement === 'ac') {
    const sizeInFoot = value * CONST_ACRE
    return sizeInFoot / CONST_F
  }
  return value
}